import { Card } from '@ui/uikit/components/common/Card';
import { Typography } from '@ui/uikit/components/common/Typography';
import { Image } from '@utilities/Image';

import type { TrustedByConfigItem } from '../trustedByConfig';
import styles from './TrustedByCard.module.scss';

export const TrustedByCard = ({
  description,
  name,
  company,
  role,
  logoUrl,
}: Omit<TrustedByConfigItem, 'id'>) => (
  <Card padding="large" className={styles.item}>
    <Typography variant="caption-s">
      {description.split('\n').map((line, index) => (
        <span key={index}>
          {line}
          <br />
        </span>
      ))}
    </Typography>
    <div className={styles.footer}>
      <div className={styles.logo}>
        <Image src={logoUrl} width={40} height={40} alt={`${company} logo`} />
      </div>
      <div className={styles.textBlock}>
        <Typography variant="caption-xs" color="tertiary">
          {name ? `${name}, ` : ''}
          {company}
        </Typography>
        {role && (
          <Typography variant="caption-xs" color="tertiary">
            {role}
          </Typography>
        )}
      </div>
    </div>
  </Card>
);
